import React from "react";
import cn from "./helpers/cn";

interface MenuItemProps extends React.OptionHTMLAttributes<HTMLOptionElement> {
  children?: React.ReactNode,
  onClick?: () => void,
  selected?: boolean,
  disabled?: boolean,
  /** Remove o padding horizontal (px-4) do item. */
  disableGutters?: boolean,
  className?: string
}

export const MenuItem = ({
  children,
  onClick,
  selected,
  disabled,
  disableGutters = false,
  className
}: MenuItemProps): JSX.Element => {
  return (
    <option
      onClick={!disabled ? onClick : undefined}
      className={cn(
        "flex items-center py-2 text-sm cursor-pointer transition-colors outline-none",
        !disableGutters && "px-4",
        selected ? "bg-primary text-contrast-text-primary font-medium" : "text-primary-tx hover:bg-slate-100",
        disabled && "opacity-50 cursor-not-allowed grayscale",
        className
      )}
      role="option"
      aria-selected={selected}
    >
      {children}
    </option>
  );
};

export default MenuItem;